(function () {
let tlYMALClone;
let overrideInstalled = false;
const getProductHandleFromPath = () => {
const match = window.location.pathname.match(/\/products\/([^/?#]+)/);
return match ? decodeURIComponent(match[1]) : null;
};
const getCurrentProductId = () => {
const currentHandle = getProductHandleFromPath();
const objectCandidates = [
{
id: window?.ShopifyAnalytics?.meta?.product?.id,
handle: window?.ShopifyAnalytics?.meta?.product?.handle
},
{
id: window?.meta?.product?.id,
handle: window?.meta?.product?.handle
}
];
for (const candidate of objectCandidates) {
if (!candidate?.id) continue;
if (!currentHandle || !candidate.handle || candidate.handle === currentHandle) {
return String(candidate.id);
}
}
const scopedSelectors = [
'main form[action*="/cart/add"] input[name="product-id"]',
'#MainContent form[action*="/cart/add"] input[name="product-id"]',
'product-info form[action*="/cart/add"] input[name="product-id"]',
'.product form[action*="/cart/add"] input[name="product-id"]',
'main [data-product-id]',
'#MainContent [data-product-id]'
];
for (const selector of scopedSelectors) {
const element = document.querySelector(selector);
const value = element?.value || element?.getAttribute?.("data-product-id");
if (value) {
return String(value);
}
}
return null;
};
const installOverride = (ymalInstance) => {
if (!ymalInstance || overrideInstalled) return;
const originalCheckCartData = ymalInstance.checkCartData?.bind(ymalInstance);
if (!originalCheckCartData) return;
overrideInstalled = true;
ymalInstance.checkCartData = async () => {
const cartData = await originalCheckCartData();
if (ymalInstance.template !== "product") {
return cartData;
}
const currentProductId = getCurrentProductId();
if (!currentProductId) {
return cartData;
}
return {
...cartData,
productInCart: [currentProductId]
};
};
setTimeout(() => {
if (ymalInstance.template === "product") {
ymalInstance.checkApplyOffer?.();
}
}, 0);
};
Object.defineProperty(window, "tlYMAL", {
configurable: true,
enumerable: true,
get() {
return tlYMALClone;
},
set(value) {
tlYMALClone = value;
installOverride(value);
}
});
if (window.tlYMAL) {
installOverride(window.tlYMAL);
}
})();